import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatAutocompleteOrigin } from '@angular/material/autocomplete';
import { MatMenuPanel, MatMenuTrigger } from '@angular/material/menu';
import { BaseViewComponent, Field, FormContainerKind, PanelTriggerDirective, Scope, TextKind } from '@sb/library/base';
import { FormFieldBaseScope } from '../form-field-base.component';

export class FormFieldContainerScope extends Scope {
    kind = Field<FormContainerKind>();
}

@Component({
    selector: 'lib-form-field-container',
    templateUrl: './form-field-container.component.html',
    styleUrls: ['./form-field-container.component.scss'],
})
export class FormFieldInputContainerComponent extends BaseViewComponent implements FormFieldContainerScope {
    Scope = this.SetScope({
        Requires: FormFieldBaseScope,
        Implements: FormFieldContainerScope,
    });

    @ViewChild('containerBox', { static: false }) containerBox!: ElementRef<HTMLDivElement>;
    @ViewChild('origin', { static: false, read: MatAutocompleteOrigin }) origin!: MatAutocompleteOrigin;
    @ViewChild(PanelTriggerDirective, { static: false}) panelContainer!: PanelTriggerDirective;
    @ViewChild(MatMenuTrigger, {static: false}) matMenuTrigger!: MatMenuTrigger;
    


    @Input() hideErrors!: boolean;
    @Input() isOptional!: boolean;
    @Input() kind: FormContainerKind = FormContainerKind.Default;
    @Input() loadingHeight: string | null = null;
    @Input() textKind: TextKind = TextKind.Default;
    @Input() matMenu: MatMenuPanel | null = null;

    
    @Output() fieldClicked: EventEmitter<MouseEvent> = new EventEmitter();
    @Output() fieldTouched: EventEmitter<TouchEvent> = new EventEmitter();
    @Output() containerClicked: EventEmitter<MouseEvent> = new EventEmitter();

    private _hideErrorsOnFocus: boolean = false;


    Focus() {
        this._hideErrorsOnFocus = this.kind !== FormContainerKind.Checkbox;
    }

    FocusOut() {
        this._hideErrorsOnFocus = false;
    }

    HelperClicked(event: MouseEvent | TouchEvent) {
        this.Scope.popover.Toggle(event);
    }

    get hideErrorsOnFocus(): boolean {
        return this._hideErrorsOnFocus;
    }

    get FormContainerKind(): typeof FormContainerKind {
        return FormContainerKind;
    }

    get hasError(): boolean {
        return this.Scope.formControl.enabled && !this.Scope.formControl.isReadOnly && !this.Scope.formControl.isLoading && this.Scope.formControl.isDirty && this.Scope.formControl.errors !== null && !this.hideErrors && !this._hideErrorsOnFocus;
    }

}
